import { router } from '@inertiajs/vue3';

export function useNotificacaoNavigation() {
    const getNotificacoesRoute = () => route('notificacoes');
    const getNotificacaoShowRoute = (notificacaoId) => route('notificacoes.show', { notificacaoId });

    const goToNotificacoes = () => router.visit(getNotificacoesRoute());
    const showNotificacao = (notificacaoId) => router.visit(getNotificacaoShowRoute(notificacaoId));

    return { getNotificacoesRoute, getNotificacaoShowRoute, goToNotificacoes, showNotificacao };
}
